'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _util = require('./util');

function reviver(key, value) {
  if ((0, _util.isObject)(value)) {
    var result = (0, _util.typeReviver)(value);

    if (result) {
      return result.value;
    }
  }

  return value;
}

exports.default = reviver;


//////////////////
// WEBPACK FOOTER
// ./~/@storybook/addon-actions/dist/lib/reviver.js
// module id = 538
// module chunks = 0